import React from 'react'
import { Helmet } from 'react-helmet';

const Welcome = () => {
    var siteTitle = "Easy Crypto Coins | Home";
    var siteDescription = "Easy Crypto Site is a list of best websites where you can earn your favorite Crpto Coins.";
    
    return (
        <>
        <Helmet>
            <meta name="description" content= {siteDescription} />
            <title>{siteTitle}</title>
        </Helmet>
        
        <section className="section-1">
        <div className="container">
            <div className="row">
                <div className="column col-md-6 pt-1">
                    <div className="mt-1">
                        <div className="jumbotron">
                        <h1 className="display-5">Welcome to Easy Crypto Coins!</h1>
                        <h2 className="lead">Where earning crypto coins made easy!</h2>
                        
                        <p>
                            Earn your favorite crypto coins by viewing PTC Ads, answering Surveys, by claiming coin from Faucet site,
                            Cloud Mining and by Trading.
                        </p>
                        <p className="lead mt-5">
                            <a className="btn zds-btn btn-lg" href="#" role="button">Learn more</a>
                        </p>
                      </div>
                    </div>
                </div>

                <div className="column col-md-6 pt-5">
                    <div className="mt-5">
                        <div className="img-banner">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>


    

    <section className="section-2 pt-5 pb-5">
        <div className="container">
            <div className="pb-5">
                <h1 className="display-4">What you can do?</h1>
            </div>
            <div className="row mt-5">
                <div className="column col-md-6">
                    <div className="left-panel">
                        <div className="img-container">
                          <img src="./images/ptc-ads.png" width="100%" alt="ptc-ads" />
                        </div>
                    </div>
                </div>
                <div className="column col-md-6">
                    <div className="right-panel">
                        <div className="text-container pt-5">
                          <h1 className="display-4">PTC Ads</h1>

                          <p className="mt-2 ml-5 mr-5">
                              Earn crypto coins by viewing Advertisements.
                          </p>
                        </div>
                    </div>
                </div>
            </div>

            
            <div className="row mt-5">
                <div className="column col-md-6">
                    <div className="left-panel">
                        <div className="text-container pt-5">
                          <h1 className="display-4">Answering Surveys</h1>

                          <p className="mt-2 ml-5 mr-5">
                              Earn higher rewards by answering Surveys from any sites you want.
                          </p>
                        </div>
                    </div>
                </div>
                <div className="column col-md-6">
                    <div className="right-panel">
                        <div className="img-container">
                          <img src="./images/survey.png" width="100%" alt="ptc-ads" />
                        </div>
                    </div>
                </div>
            </div>

            
            <div className="row mt-5">
                <div className="column col-md-6">
                    <div className="left-panel">
                        <div className="img-container">
                          <img src="./images/faucet.png" width="100%" alt="ptc-ads" />
                        </div>
                    </div>
                </div>
                <div className="column col-md-6">
                    <div className="right-panel">
                        <div className="text-container pt-5">
                          <h1 className="display-4">Faucets</h1>

                          <p className="mt-2 ml-5 mr-5">
                              Earn coins by claiming from various Faucet sites.
                          </p>
                        </div>
                    </div>
                </div>
            </div>

            
            <div className="row mt-5">
                <div className="column col-md-6">
                    <div className="left-panel">
                        <div className="text-container pt-5">
                          <h1 className="display-4">Cloud Mining</h1>

                          <p className="mt-2 ml-5 mr-5">
                            Mine your favorite crypto coins without using your computer's hardware.
                          </p>
                        </div>
                    </div>
                </div>
                <div className="column col-md-6">
                    <div className="right-panel">
                        <div className="img-container">
                          <img src="./images/cloud-mining.png" width="100%" alt="ptc-ads" />
                        </div>
                    </div>
                </div>
            </div>

            
            <div className="row mt-5">
                <div className="column col-md-6">
                    <div className="left-panel">
                        <div className="img-container">
                          <img src="./images/trading.png" width="100%" alt="ptc-ads" />
                        </div>
                    </div>
                </div>
                <div className="column col-md-6">
                    <div className="right-panel">
                        <div className="text-container pt-5">
                          <h1 className="display-4">Trading</h1>

                          <p className="mt-2 ml-5 mr-5">
                              Earn coins by claiming from various Faucet sites.
                          </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>


    
    <section className="section-3 pt-5 pb-5">
        <div className="container pb-5">
            <h1 className="display-4">Don't Get Behind!</h1>
            <p className="text-muted">
                Claiming or earning Crypto Coins is not easy. You need to have more additional Faucet Sites or PTC Ads Site
                so you can earn more coins. But the problem is, you have to bookmark those sites to make it easier for you to 
                access it at anytime, but, most people don't like that especially me so I created this site for my self and 
                share it with you.
            </p>
            <p className="text-muted">
                Feel free to use this site!
            </p>
        </div>
        <div className="container pb-5">
            <h1 className="display-4">Find It Useful?</h1>
            <p className="text-muted">
                If you find this site useful, please spread the world! <br/>
                If you are so kind enough for my effort, buying me a coffee <br/> is greatly appreciated!
            </p>
        </div>
    </section>            
        </>
    );
};

export default Welcome;
